import React from 'react';
import Container from '../layout/Container';
import Eyebrow from '../ui/Eyebrow';
import SectionHeading from '../ui/SectionHeading';
import { colors, font } from '../../lib/tokens';

const ROAD = [
  { when: 'Now',   title: 'Landspítali, in production', desc: 'Emergency department, doctor’s letters and outpatient clinics at Iceland’s national university hospital.' },
  { when: '2027+', title: 'Nordic expansion',           desc: 'Rollout to partner hospitals across Denmark, Sweden, and Norway.' },
  { when: '2027+', title: 'Multilingual clinical NLP',  desc: 'Clinical language models across English, Icelandic, German, Mandarin.' },
];

export default function InvestorVisionSection() {
  return (
    <section
      id="vision"
      className="kc-section"
      style={{
        background: colors.bg,
        borderTop: `1px solid ${colors.hair}`,
      }}
    >
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-[1fr_1.3fr] gap-12 md:gap-24">
          <div data-reveal>
            <Eyebrow>Vision</Eyebrow>
            <SectionHeading style={{ marginBottom: 24 }}>
              The infrastructure layer
              {' '}<br />
              for clinical coding.
            </SectionHeading>
            <p style={{ color: colors.muted, fontSize: 16, lineHeight: 1.65, maxWidth: 400 }}>
              Iceland is our proving ground: a small, fully digitised health system where every
              encounter flows through one EHR. What works here scales.
            </p>
          </div>
          <div>
            {ROAD.map((r, i) => (
              <div
                key={r.title}
                data-reveal
                className="kc-label-row"
                style={{
                  '--d': `${80 + i * 80}ms`,
                  padding: '28px 0',
                  borderTop: `1px solid ${colors.hair}`,
                  borderBottom: i === ROAD.length - 1 ? `1px solid ${colors.hair}` : 'none',
                } as React.CSSProperties}
              >
                <div
                  className="kc-label-row-label"
                  style={{
                    fontFamily: font.mono,
                    fontSize: 11,
                    color: i === 0 ? colors.blue : colors.muted,
                    letterSpacing: 1,
                    textTransform: 'uppercase',
                  }}
                >
                  {r.when}
                </div>
                <div>
                  <div
                    style={{
                      fontSize: 20,
                      fontWeight: 500,
                      color: colors.ink,
                      letterSpacing: -0.3,
                    }}
                  >
                    {r.title}
                  </div>
                  <p
                    style={{
                      color: colors.muted,
                      fontSize: 15,
                      lineHeight: 1.65,
                      margin: '8px 0 0',
                    }}
                  >
                    {r.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}
